module.exports = __webpack_public_path__ + "static/media/icon-volver_adjuntar.306b95e5.svg";